import { Requester } from './Requester';
import { IUserDocumentPopulated, TableQueryParams } from '../types';

export const GetUsers = async (
    options: TableQueryParams
): Promise<{ users: IUserDocumentPopulated[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{ users: IUserDocumentPopulated[]; totalRecords: number }>({
            path: `users/paged`,
            method: 'PUT',
            payload: options
        });

        if ('users' in response && Array.isArray(response.users)) return response;
        return null;
    } catch (e) {
        console.error('Get users request failed');
        return Promise.reject(e);
    }
};
